import { maLookback } from '../../math/ma'
import { COLOR, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'PPO',
  version: 1,
  label: 'Percentage Price Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 220,
  inputs: [period('fastperiod', 12, 'Fast length'), period('slowperiod', 26, 'Slow length'), matype()],
  outputs: [line('ppo', 'PPO', COLOR.blue)],
  levels: [{ value: 0 }],
  talib: { functions: ['PPO'], expr: 'PPO(close, fastperiod={fastperiod}, slowperiod={slowperiod}, matype={matype})' },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, slowperiod, matype }) => maLookback(Math.max(fastperiod, slowperiod), matype),
}
export default def
